/**
 * crudEditStore
 * 编辑页面共用逻辑以及部分子组件与父组件通讯
 */

let flashAddMedicalAndCurdArray = (crudEditStore, selfData) => {
  crudEditStore.states['selfData'] = selfData
  return crudEditStore
}

export default flashAddMedicalAndCurdArray
